<template>
  <base-modal
    name="basic-modal"
    :visible="show"
    :close-button="false"
    :close-outside="false"
    @close="closeModal"
  >
    <div class="flex flex-col">
      <h3
        class="text-2xl font-bold leading-6 text-color-1 max-w-[250px] overflow-hidden text-ellipsis whitespace-nowrap mb-8"
      >
        {{ $t('ApiKey | SecretKey') }}
      </h3>

      <div
        class="text-sm flex justify-center text-center bg-attention-bg text-attention-text mb-5 py-4 px-4 rounded-sm"
      >
        {{ $t('ApiKey | Attention') }}
      </div>

      <div class="mb-5">
        <base-input
          :model-value="formData.api_secret"
          readonly
          label="API Secret"
        />
      </div>

      <div class="flex flex-col gap-y-10">
        <base-button
          :type="isCopy ? 'shade' : 'cta'"
          class="!w-full"
          @onClick="onCopy(formData.api_secret)"
        >
          <div class="flex gap-x-3">
            <svg-icon class="!w-6 !h-6" name="ic-copy" />

            <div class="font-normal">
              {{ $t('ApiKey | buttonCopy') }}
            </div>
          </div>
        </base-button>

        <base-button
          class="!w-full"
          :type="isCopy ? 'cta' : 'shade'"
          :disabled="!isCopy"
          @onClick="closeModal"
        >
          <div class="font-normal">
            {{ $t('ApiKey | buttonSubmit') }}
          </div>
        </base-button>
      </div>
    </div>
  </base-modal>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import BaseInput from '@emcd-shared/base-input'
import BaseModal from '@emcd-shared/base-modal'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'

import { API_KEY_GETTERS } from '@/shared/constants'
import { APP_DISPATCHERS } from '@/shared/constants/store-constants/app'
import { ROUTES } from '@/shared/constants/routes'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue', 'onUpdate'])

const store = useStore()
const router = useRouter()

const isCopy = ref(false)

const formData = reactive({
  name: '',
  api_key: '',
  api_secret: '',
})

const show = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})

const formDataStore = computed(() => store.getters[API_KEY_GETTERS.formData])

function parseData() {
  Object.keys(formData).forEach((key) => {
    formData[key] = formDataStore.value[key]
  })
}

async function onCopy(text) {
  isCopy.value = true
  await store.dispatch(APP_DISPATCHERS.copyToClipboard, text)
}

function closeModal() {
  show.value = false
  router.push(ROUTES.API_AND_INTEGRATION.LIST)
}

watch(show, (value) => {
  if (value) {
    parseData(value)
  }
})
</script>
